module.exports = __webpack_public_path__ + "static/media/safety.a7dbba40.png";